import React,{useEffect,useState} from 'react'
import { Link,useNavigate,useLocation } from 'react-router-dom'
import Logo from '../../assets/images/logo.png'
import StudentImg from '../../assets/images/login-students.png'
import LoginVector from '../../assets/images/login-vector.png'
import LoginForm from '../../components/Auth/LoginForm'
import queryString from 'query-string'

const Login = () => {
    const navigate = useNavigate();
    const[utmParams,setUtmParams]=useState({})
    const location = useLocation();

    useEffect(() => {
        window.gtag("config", "UA-185641939-1", {
        page_title: location.pathname,
        page_path:location.pathname,
        })
      }, [location]);
      
        useEffect(() => {
          window.gtag("config", "GTM-WD9H59N", {
          page_title: location.pathname,
          page_path:location.pathname,
          })
      }, [location]);
      
    useEffect(() => {
        if(sessionStorage.getItem('token')){
            navigate('/student/dashboard');
        }

        const qParams = queryString.parse(location.search);
        if (qParams !== null) {
            const{source,lead_source,campaign_name,utm_adgroup,utm_campaign,utm_medium,utm_source,utm_term} =qParams
            let utmObj={
                channel_name:'Digital Marketing',
                current_channel_name:'Digital Marketing',
                source:source?source:'',
                lead_source:lead_source?lead_source:'',
                campaign_name:campaign_name?campaign_name:'',
                utm_adgroup:utm_adgroup?utm_adgroup:'',
                utm_campaign:utm_campaign?utm_campaign:'',
                utm_medium:utm_medium?utm_medium:'',
                utm_source:utm_source?utm_source:'',
                utm_term:utm_term?utm_term:'',
                is_login:1,
            }
            
            setUtmParams(utmObj)
        }
    },[])
  return (
    <div className="login_page ">
        <div className="container">
            <div className="row login_register_form justify-content-between align-items-center">
                <div className="col-lg-12">
                    
                </div>
                <div className="col-lg-5">
                    <div className="login_left">
                        <img src={Logo} className="img-fluid" alt="Logo"/>
                        <h1>Welcome Student</h1>
                        <h2>Login to your Account</h2>

                        <p>Don't have an account ? <Link to="/register" className="text-decoration-none text-primary fw-bold" title="Register Now">Register Now</Link></p>
                        {/* <p className='my-4'><a href="https://demoworkshop.allenoverseas.com/" className='text-decoration-none my-4 fw-bold text-white border bg-secondary rounded py-2 px-3' target="_blank" rel="noreferrer">Click Here To Join The Webinar </a></p> */}

                        <LoginForm utmParams={utmParams}/>
                    </div>
                </div>

                <div className="col-lg-6 d-none d-lg-block align-self-stretch position-relative">
                    <div className="login_student_col login_right_content position-relative">
                        <img src={StudentImg} alt="Student pic"/>
                        <h2>ALLEN Overseas - Inspiring Success Beyond Borders </h2>
                        <p>Your Journey to Academic Excellence Begins Here</p>
                        <p>📚: Expert Faculty | 🌍: Global Reach | 🏆: Proven Results</p>
                        <p><em>Join the community where learning knows no boundaries.</em></p>
                        <p><b>Empowering Students Worldwide</b></p>
                    </div>

                    <img src={LoginVector} className="img-fluid login_vector_img" alt="vector img"/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Login